import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import address from './address';
import app from './app';
import comparables from './comparables';
import filter from './filter';
import { marketStats, unfilteredMarketStats } from './marketStats';
import search from './search';
import topMarkets from './topMarkets';
import ui from './ui';
import user from './user';

const rootReducer = (history) =>
    combineReducers({
        app,
        address,
        comparables,
        filter,
        marketStats,
        search,
        topMarkets,
        ui,
        unfilteredMarketStats,
        user,
        router: connectRouter(history)
    });

export default rootReducer;
